export default __webpack_public_path__ + "static/media/Course-Icons9.89605cd8.svg";